import {
  Chart as ChartJS,
  LineController,
  BarController,
  DoughnutController,
  PieController,
  LineElement,
  PointElement,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  Filler,
  Legend,
  Tooltip
} from 'chart.js';
// @todo replace moment with date-fns
import 'chartjs-adapter-moment';
import Zoom from 'chartjs-plugin-zoom';
import Annotation from 'chartjs-plugin-annotation';
import DataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'react-chartjs-2';
import { findBestResolution, adjustTimeRange, tooltipCursorPositioner } from './utils';
import { Crosshair, Marker } from './plugins';

Tooltip.positioners.cursor = tooltipCursorPositioner;
// Makes tooltip work during drag zoom
// Zoom.beforeEvent disables all chart events on grad or pan.
Zoom.beforeEvent = undefined;

ChartJS.register(
  // Controllers
  LineController,
  BarController,
  DoughnutController,
  PieController,
  // Elements
  LineElement,
  PointElement,
  BarElement,
  ArcElement,
  // scales
  CategoryScale,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  // plugins
  Filler,
  Legend,
  Tooltip,
  Zoom,
  Annotation,
  DataLabels,
  Marker,
  Crosshair
);

ChartJS.defaults.plugins.datalabels.display = false;

export { Chart, findBestResolution, adjustTimeRange };
